module.exports = __webpack_public_path__ + "img/bg_slide_4.1f8f9608.jpeg";